import { Button, Flex, Text } from "@chakra-ui/react";

import { palette } from "@/containers/app/summary/components/ui";

/**
 * The failure states of an org-scoped read, shared by both org screens.
 * FORBIDDEN and NOT_FOUND mean the grant on this organization is gone, which
 * retrying cannot fix; everything else is transient and gets a button.
 */
export const OrgQueryError = ({
  message,
  code,
  onRetry,
}: {
  message: string;
  code: string | undefined;
  onRetry: () => void;
}): JSX.Element => {
  const lostAccess = code === "FORBIDDEN" || code === "NOT_FOUND";

  return (
    <Flex direction="column" align="center" gap={3} py={10} textAlign="center">
      <Text fontSize="sm" color={palette.text} fontWeight="medium">
        {lostAccess
          ? "No tienes acceso a esta organización"
          : `No pudimos cargar ${message}`}
      </Text>
      <Text fontSize="xs" color={palette.muted} maxW="sm">
        {lostAccess
          ? "Selecciona otra organización o un comercio en el menú lateral."
          : "Vuelve a intentarlo en unos segundos."}
      </Text>
      {!lostAccess && (
        <Button size="sm" variant="outline" onClick={onRetry}>
          Reintentar
        </Button>
      )}
    </Flex>
  );
};
